import { A as Autoplay, N as Navigation, P as Pagination, S as Swiper } from './autoplay-BtrMVxY0.js';
import { A as A11y, S as Scrollbar } from './a11y-CPk6DMtX.js';

class ProductRecommendations extends HTMLElement {
  /**  @type {HTMLElement} */
  swiperElement = this.querySelector('[data-swiper]');

  swiperOptions = {
    modules: [A11y, Autoplay, Navigation, Pagination, Scrollbar],
    threshold: 10,
  };

  connectedCallback() {
    // Check if we have extra options on the HTML
    this.swiperOptions = {
      ...this.swiperOptions,
      ...JSON.parse(this.swiperElement.dataset.options || '{}'),
    };

    this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

    // Only do it once, not on every web component render.
    window.onload = () => {
      this.init();
    };
  }

  init() {
    if (this.dataset && this.dataset.url) {
      this.fetchRecommendations(this.dataset.url);
    }
  }

  fetchRecommendations(url) {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-recommended-products]')?.innerHTML;

        if (!html) {
          if (this.dataset.fallbackIntent && !this.hasTriedFallback) {
            this.hasTriedFallback = true;
            const fallbackUrl = this.dataset.url.replace(
              /intent=\w+/,
              `intent=${this.dataset.fallbackIntent}`
            );
            this.fetchRecommendations(fallbackUrl);
            return;
          }

          this.replaceChildren();
          const p = document.createElement('p');
          p.textContent = this.dataset.noRecommendationsFound || 'No recommendations found';
          p.classList.add('text-center');
          this.appendChild(p);
          return;
        }
        this.querySelector('[data-recommended-products]').innerHTML = html;

        this.swiperInstance.update();
        if (this.swiperOptions.navigation) {
          this.swiperInstance.navigation.init();
          this.swiperInstance.navigation.update();
        }
        if (this.swiperOptions.pagination) {
          this.swiperInstance.pagination.init();
          this.swiperInstance.pagination.update();
        }
        if (this.swiperOptions.scrollbar) {
          this.swiperInstance.scrollbar.init();
          this.swiperInstance.scrollbar.updateSize();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);
